import * as types from './mutations-types'

export const setToken = function ({commit, state}, name) {
  commit(types.SET_TOKEN, name)
}
export const setSalesFlag = function ({commit, state}, name) {
  commit(types.SET_SALES_FLAG, name)
}



// WEBPACK FOOTER //
// ./src/store/actions.js